export default {
  // 判断终端设备类型
  isMobile() {
    const userAgent = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    return userAgent
  },
  // 元素滚动到浏览器窗口的可视区域内
  scrollIntoView(id) {
    document.getElementById(id).scrollIntoView();
  }
}